(function () {
  'use strict';

  function initialise() {
    var gallery = document.querySelector('[data-royal-gallery]');
    if (!gallery || gallery.dataset.royalInitialised === 'true') return;
    var catalogNode = gallery.querySelector('[data-royal-catalog]');
    var catalog;
    try { catalog = JSON.parse(catalogNode.textContent); } catch (_) { return; }
    if (!Array.isArray(catalog) || !catalog.length) return;
    var displayImages = {};
    var displayNode = gallery.querySelector('[data-royal-display-images]');
    try { if (displayNode) displayImages = JSON.parse(displayNode.textContent); } catch (_) {}
    gallery.dataset.royalInitialised = 'true';

    var chosen = catalog[0];
    var filter = 'all';
    var exampleMode = 'mixed';
    var petName = '';
    var goldFrame = true;
    var custom = false;
    var customPerson = '';
    var locked = false;
    var nameInput = gallery.querySelector('[data-royal-name]');
    var currentLabel = gallery.querySelector('[data-royal-current]');
    var status = gallery.querySelector('[data-royal-status]');
    var cards = Array.from(gallery.querySelectorAll('[data-royal-preset]'));
    var filters = Array.from(gallery.querySelectorAll('[data-royal-filter]'));
    var speciesControls = Array.from(gallery.querySelectorAll('button[data-royal-species]'));
    var goldControls = Array.from(gallery.querySelectorAll('[data-royal-gold-option]'));
    var customOpenControls = Array.from(gallery.querySelectorAll('[data-royal-custom-open]'));
    var api = window.BellissimaRoyalPawtraits || {};

    function matchesFilter(figure) {
      return filter === 'all' || (filter === 'rock' ? figure.collection === 'rock' : figure.tags.indexOf(filter) >= 0);
    }
    function figureImage(figure) {
      return (exampleMode === 'mixed' ? figure.image : exampleMode === 'cat' ? figure.catImage : figure.dogImage) || figure.image;
    }
    function figureSpecies(figure) {
      return exampleMode === 'mixed' ? (figure.tags.indexOf('cat') >= 0 ? 'cat' : 'dog') : exampleMode;
    }
    function displayImage(image, figure) {
      var original = figureImage(figure);
      var display = displayImages[original];
      var source = display ? display.small : original;
      var srcset = display ? display.small + ' 320w, ' + display.large + ' 640w' : '';
      if (srcset) {
        if (image.getAttribute('srcset') !== srcset) image.setAttribute('srcset', srcset);
      } else image.removeAttribute('srcset');
      if (image.getAttribute('src') !== source) image.setAttribute('src', source);
      image.alt = 'Example ' + figureSpecies(figure) + ' portrait as ' + figure.name;
    }

    api.state = function () {
      if (custom) return { slug: 'custom-famous-person', name: customPerson || 'Your own famous person',
        brief: 'Dress the customer’s pet in a recognisable costume and pose inspired by ' + (customPerson || 'the famous person requested by the customer') + '. Preserve the pet’s exact animal identity and natural animal face; never replace its face with a human face.',
        petName: petName, goldFrame: goldFrame, prefix: '', image: figureImage(catalog[0]), species: figureSpecies(catalog[0]), exampleMode: exampleMode, customPerson: customPerson, custom: true };
      return { slug: chosen.slug, name: chosen.name, brief: chosen.brief,
        petName: petName, goldFrame: goldFrame, prefix: chosen.prefix, image: figureImage(chosen), species: figureSpecies(chosen), exampleMode: exampleMode, customPerson: '', custom: false };
    };
    api.lock = function (value) {
      locked = Boolean(value);
      gallery.setAttribute('aria-busy', String(locked));
      gallery.querySelectorAll('button, input').forEach(function (control) {
        control.disabled = locked;
      });
    };
    api.set = function (values) {
      if (locked || !values || typeof values !== 'object') return api.state();
      var previous = JSON.stringify([chosen.slug,custom,customPerson,petName,goldFrame,exampleMode]);
      if (typeof values.slug === 'string') {
        if (values.slug === 'custom-famous-person') custom = true;
        else {
          var figure = catalog.find(function (item) { return item.slug === values.slug; });
          if (figure) {
            custom = false;
            chosen = figure;
            if (!matchesFilter(figure)) filter = 'all';
          }
        }
      }
      if (Object.prototype.hasOwnProperty.call(values, 'customPerson')) customPerson = String(values.customPerson == null ? '' : values.customPerson).replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, 100);
      if (Object.prototype.hasOwnProperty.call(values, 'petName')) {
        petName = String(values.petName == null ? '' : values.petName).slice(0, 18).trim();
        if (nameInput) nameInput.value = petName;
      }
      if (Object.prototype.hasOwnProperty.call(values, 'goldFrame')) {
        goldFrame = values.goldFrame === true || values.goldFrame === 'true';
      }
      if (values.exampleMode === 'mixed' || values.exampleMode === 'dog' || values.exampleMode === 'cat') exampleMode = values.exampleMode;
      else if (values.species === 'dog' || values.species === 'cat') exampleMode = values.species;
      gallery.dataset.royalGold = String(goldFrame);
      gallery.dataset.royalSpecies = api.state().species;
      gallery.dataset.royalExampleMode = exampleMode;
      speciesControls.forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.royalSpecies === exampleMode)); });
      goldControls.forEach(function (button) { button.setAttribute('aria-pressed', String((button.dataset.royalGoldOption === 'true') === goldFrame)); });
      updateCards();
      updateHero();
      if (previous !== JSON.stringify([chosen.slug,custom,customPerson,petName,goldFrame,exampleMode])) changed();
      return api.state();
    };
    window.BellissimaRoyalPawtraits = api;

    function changed() {
      gallery.dispatchEvent(new CustomEvent('royal-pawtraits:change', { bubbles: true, detail: api.state() }));
    }

    function plaques() {
      gallery.querySelectorAll('[data-royal-prefix]').forEach(function (plaque) {
        plaque.textContent = [plaque.dataset.royalPrefix, petName || 'Your Pet'].filter(Boolean).join(' ');
      });
    }

    function updateCards() {
      cards.forEach(function (card) {
        var figure = catalog.find(function (item) { return item.slug === card.dataset.royalPreset; });
        var isChosen = !custom && card.dataset.royalPreset === chosen.slug;
        card.hidden = !!figure && !matchesFilter(figure);
        if (figure && !card.hidden) {
          var image = card.querySelector('.royal-card-media img');
          displayImage(image, figure);
        }
        card.setAttribute('aria-pressed', String(isChosen));
        card.querySelector('.royal-card-selection').textContent = isChosen ? 'Selected' : 'Choose portrait';
      });
      currentLabel.textContent = api.state().name;
      customOpenControls.forEach(function (button) { button.setAttribute('aria-pressed', String(custom)); });
      filters.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.royalFilter === filter));
      });
    }

    function openPortrait() {
      document.dispatchEvent(new CustomEvent('royal-pawtraits:open', { detail: api.state() }));
    }

    function updateHero() {
      var slugs = filter === 'rock' ? ['rock-03-starman', 'rock-01-champion', 'rock-02-rocket-man'] : ['03-elizabeth-i', '01-churchill', '02-henry-viii'];
      gallery.querySelectorAll('.royal-hero-portrait').forEach(function (portrait, index) {
        var figure = catalog.find(function (item) { return item.slug === slugs[index]; });
        if (!figure) return;
        var image = portrait.querySelector('img');
        displayImage(image, figure);
        portrait.querySelector('[data-royal-prefix]').dataset.royalPrefix = figure.prefix;
      });
      plaques();
    }

    if (nameInput) nameInput.addEventListener('input', function () {
      if (locked) return;
      var nextName = nameInput.value.slice(0, 18).trim();
      if (nextName === petName) return;
      petName = nextName;
      plaques();
      changed();
    });

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (locked) return;
        api.set({ slug: card.dataset.royalPreset });
        status.textContent = chosen.name + ' selected.';
        openPortrait();
      });
    });
    customOpenControls.forEach(function (button) {
      button.addEventListener('click', function () {
        if (locked) return;
        api.set({ slug: 'custom-famous-person' });
        status.textContent = 'Your own famous person selected.';
        openPortrait();
      });
    });

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        if (locked) return;
        var nextFilter = button.dataset.royalFilter;
        filter = filter === nextFilter ? 'all' : nextFilter;
        updateCards();
        updateHero();
      });
    });

    speciesControls.forEach(function (button) {
      button.addEventListener('click', function () {
        if (locked) return;
        var nextSpecies = button.dataset.royalSpecies;
        api.set({ exampleMode: exampleMode === nextSpecies ? 'mixed' : nextSpecies });
        status.textContent = (exampleMode === 'mixed' ? 'Mixed dog and cat' : exampleMode === 'cat' ? 'Cat' : 'Dog') + ' examples selected.';
      });
    });

    goldControls.forEach(function (button) {
      button.addEventListener('click', function () {
        if (locked) return;
        api.set({ goldFrame: button.dataset.royalGoldOption === 'true' });
      });
    });

    gallery.querySelector('[data-royal-choose]').addEventListener('click', function () {
      if (locked) return;
      var target = gallery.querySelector('[data-royal-collection-start]');
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      target.focus({ preventScroll: true });
    });
    gallery.querySelector('[data-royal-personalise]').addEventListener('click', function () {
      if (!locked) openPortrait();
    });
    updateCards();
    plaques();
    changed();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
